import { JourneySteps } from "../../shared/types/strings.type";

export abstract class JourneyConfig{

    public static steps: Array<JourneySteps> =  [
        {
            step: 1,
            label: '1',
            route: 'event',
            isActive: true,
            fragment: 'rttd'
        },
        {
            step: 2,
            label: '2',
            route: 'event-appointment',
            isActive: false,
            fragment: 'rttd'
        },
        {
            step: 3,
            label: '3',
            route: 'event-personal-information',
            isActive: false,
            fragment: 'rttd'
        },
        {
            step: 4,
            label: '4',
            route: 'event-confirmation',
            isActive: false,
            fragment: 'rttd'
        }
    ]
}